module.exports = __webpack_public_path__ + "img/0Q3A6453_L_WoodMatted_MockedUp.9b1f489f.jpg";